


















import { Component, Prop, Vue } from 'nuxt-property-decorator';

import { IconFile, IconImport } from '@/icons';

@Component({
  components: {
    IconFile,
    IconImport,
  },
})
export default class DownloadableFile extends Vue {
  @Prop({ type: String, required: true })
  fileName!: string

  @Prop({ type: String, required: true })
  fileType!: string

  @Prop({ type: String, required: true })
  fileUrl!: string
}
